import React, { useCallback } from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import ToolbarBlockType from './ToolbarBlockType';
var FloatingToolbarSettings = {
  isSmall: true,
  disabled: false,
  isToolbarReducedSpacing: true,
  shouldUseDefaultRole: false
};
export function FloatingToolbarComponent(_ref) {
  var api = _ref.api;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['blockType'], function (states) {
      var _states$blockTypeStat, _states$blockTypeStat2, _states$blockTypeStat3, _states$blockTypeStat4, _states$blockTypeStat5;
      return {
        currentBlockType: (_states$blockTypeStat = states.blockTypeState) === null || _states$blockTypeStat === void 0 ? void 0 : _states$blockTypeStat.currentBlockType,
        blockTypesDisabled: (_states$blockTypeStat2 = states.blockTypeState) === null || _states$blockTypeStat2 === void 0 ? void 0 : _states$blockTypeStat2.blockTypesDisabled,
        availableBlockTypes: (_states$blockTypeStat3 = states.blockTypeState) === null || _states$blockTypeStat3 === void 0 ? void 0 : _states$blockTypeStat3.availableBlockTypes,
        availableBlockTypesInDropdown: (_states$blockTypeStat4 = states.blockTypeState) === null || _states$blockTypeStat4 === void 0 ? void 0 : _states$blockTypeStat4.availableBlockTypesInDropdown,
        formattingIsPresent: (_states$blockTypeStat5 = states.blockTypeState) === null || _states$blockTypeStat5 === void 0 ? void 0 : _states$blockTypeStat5.formattingIsPresent
      };
    }),
    currentBlockType = _useSharedPluginState.currentBlockType,
    blockTypesDisabled = _useSharedPluginState.blockTypesDisabled,
    availableBlockTypes = _useSharedPluginState.availableBlockTypes,
    availableBlockTypesInDropdown = _useSharedPluginState.availableBlockTypesInDropdown,
    formattingIsPresent = _useSharedPluginState.formattingIsPresent;
  var boundSetBlockType = useCallback(function (name, fromBlockQuote) {
    var _api$core, _api$blockType;
    return api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.setTextLevel(name, INPUT_METHOD.FLOATING_TB, fromBlockQuote));
  }, [api]);
  var wrapBlockQuote = useCallback(function () {
    var _api$core2, _api$blockType2;
    return api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 ? void 0 : _api$core2.actions.execute(api === null || api === void 0 || (_api$blockType2 = api.blockType) === null || _api$blockType2 === void 0 || (_api$blockType2 = _api$blockType2.commands) === null || _api$blockType2 === void 0 ? void 0 : _api$blockType2.insertBlockQuote(INPUT_METHOD.FLOATING_TB));
  }, [api]);
  var clearFormatting = useCallback(function () {
    var _api$core3, _api$blockType3;
    return api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 ? void 0 : _api$core3.actions.execute(api === null || api === void 0 || (_api$blockType3 = api.blockType) === null || _api$blockType3 === void 0 || (_api$blockType3 = _api$blockType3.commands) === null || _api$blockType3 === void 0 ? void 0 : _api$blockType3.clearFormatting(INPUT_METHOD.FLOATING_TB));
  }, [api]);
  return /*#__PURE__*/React.createElement(ToolbarBlockType, {
    isSmall: FloatingToolbarSettings.isSmall,
    isDisabled: FloatingToolbarSettings.disabled,
    isReducedSpacing: editorExperiment('platform_editor_controls', 'variant1') ? false : FloatingToolbarSettings.isToolbarReducedSpacing,
    setTextLevel: boundSetBlockType,
    currentBlockType: currentBlockType,
    blockTypesDisabled: blockTypesDisabled,
    availableBlockTypes: availableBlockTypes,
    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
    formattingIsPresent: formattingIsPresent,
    wrapBlockQuote: wrapBlockQuote,
    clearFormatting: clearFormatting,
    shouldUseDefaultRole: FloatingToolbarSettings.shouldUseDefaultRole,
    api: api
  });
}